import { useAuth } from "@contexts/authContext";

const HELP_CENTER_URL = "https://qontact.notion.site/Centro-de-ayuda-17e2ff5f093880eeb051f78b18fec544";

export const useProfileScreenViewModel = () => {
    const { user, dashboardUser, logOut } = useAuth();

    const openHelpCenter = () => {
        const newWindow = window.open(HELP_CENTER_URL, "_blank");
        newWindow?.focus();
    };

    return {
        displayName: dashboardUser?.name ?? user?.displayName ?? user?.email ?? "",
        imageURL: dashboardUser?.image ?? user?.photoURL ?? undefined,
        openHelpCenter,
        logOut,
    };
};
